export const environment = {
  production: false,
  apiUrl: 'https://dev11.prosolonline.com',
};
